import { createApi } from '@reduxjs/toolkit/dist/query/react';

import { baseQueryWithIntercept } from '@apis/fetchBaseQuery';
import {
    LocateProductlDTO,
    LocateProductResponse,
    REQUEST_PATH
} from '@apis/manageInventory/LocateProduct.type';

export const locateProductApi = createApi({
    reducerPath: 'locateProductApi',
    baseQuery: baseQueryWithIntercept,
    endpoints: (builder) => ({
        locateProduct: builder.mutation<
            LocateProductResponse,
            LocateProductlDTO
        >({
            query: (dto) => ({
                url: REQUEST_PATH.LOCATE_PRODUCT,
                method: 'POST',
                body: dto
            })
        })
    })
});

export const { useLocateProductMutation } = locateProductApi;
